import {DELETE_QUESTIONS_START} from "../../types";

export const delete_questions = (payload) => ({
    type: DELETE_QUESTIONS_START,
    payload,
});
